const getters = {
  getBranchSchemeList(state) {
    return state.branchSchemeList;
  },
  getBranchScheme(state) {
    return state.branchScheme;
  },
  getLinesGridData(state) {
    return state.linesGridData;
  },
  getBranchSchemeLinesList(state) {
    return state.branchSchemeLinesList;
  },
  };
  
  export default getters;